import { http } from '@/utils/http';
import qs from 'qs';

const baseUrl = '/vote/2020project/2020cqfootballnews/controller.php?enews=';

interface IVoteListOption {
  search?: string | number;
  page?: number;
  cid?: number | string;
}
export const getBaseInfo = () => {
  return http.get(`${baseUrl}base-info`);
};
// 列表
export const voteList = ({ page, search, cid }: IVoteListOption) => {
  return http.get(`${baseUrl}vote-list`, {
    params: { page, search, cid },
  });
};

// 书记导风景，醉美一分钟视频地址
export const videoUrlList = () => {
  return http.get(`${baseUrl}videoUrl-list`);
};

// 规则
export const getRules = () => {
  return http.get(`${baseUrl}rules`);
};

// 获取详情页面
export const detail = (id: any) => {
  return http.get(`${baseUrl}detail&id=` + id);
};

// 新闻列表
export const getNewslist = (page: number) => {
  return http.get(`${baseUrl}ball-time`, {
    params: { page },
  });
};
// 新闻列表2
export const getNewslist2 = (page: number) => {
  return http.get(`${baseUrl}cq-temperature`, {
    params: { page },
  });
};

// 新闻列表3
export const getNewslist3 = (page: number) => {
  return http.get(`${baseUrl}thousand-outfield`, {
    params: { page },
  });
};
